import { render, staticRenderFns } from "./CustomExerciseEdit.vue?vue&type=template&id=2fc5c48e"
import script from "./CustomExerciseEdit.vue?vue&type=script&lang=js"
export * from "./CustomExerciseEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomExerciseEdit.vue?vue&type=style&index=0&id=2fc5c48e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports